/**
 * Zustand store for Settings page tab state.
 * Allows any part of the app to deep-set the active Settings tab
 * before navigating to the Settings page.
 */

import { create } from 'zustand';

export type SettingsTab = 'apiTokens' | 'exchangeKeys' | 'riskControls' | 'notifications';

interface SettingsStore {
  activeTab: SettingsTab;
  setActiveTab: (tab: SettingsTab) => void;
  /** Reset to the default tab. Called on logout/login (SHA-71). */
  reset: () => void;
}

export const useSettingsStore = create<SettingsStore>((set) => ({
  activeTab: 'apiTokens',
  setActiveTab: (tab) => set({ activeTab: tab }),
  reset: () => set({ activeTab: 'apiTokens' }),
}));
